import { ComponentInstance, onBeforeMount } from "@vue/composition-api";

const useGetTableLibs = (root: ComponentInstance): void => {
  const store = root.$store;

  onBeforeMount(() => {
    store.dispatch("storageCatalogView/getTypes");
    store.dispatch("storageCatalogView/getArchivesData");
  });
};

export default useGetTableLibs;
